import {getCookieAgeFromAction} from '../getCookieAgeFromAction'
import AnalyticsUtils from '../../../analytics/utils'
import {logEvent} from '../../../analytics/modules/middleware'
import {trackEvent} from '../../../analytics/modules/actions'
import {Action, Category, Entity, Team} from '../../../analytics/types/Events'

import {FetchAccessControlParams, Hits} from '../../types'
import {ALLOW_TOKEN, DENY_TOKEN} from '../constants'

export const INDIAN_COUNTRY_CODE = 'IN'

/**
 * Track user matched the DENY list
 * @param eventData - object containing cookieAge and ruleId
 * @param user - user data
 * @param dispatch - redux dispatch
 */
const trackDeniedMatches = (eventData, user, dispatch) => {
  AnalyticsUtils.trackEvent('AccessControlListDenied', eventData)
  const metadata = {
    ...eventData,
    anonymousId: user?.anonymousId,
    userId: user?.userId
  }

  logEvent('AccessControlListDenied', metadata)

  dispatch(
    trackEvent({
      category: Category.System,
      entity: Entity.AccessControlListDenied,
      action: Action.Served,
      payload: eventData,
      team: Team.Retention
    })
  )
}

/**
 * Track user matched the ALLOW list
 * @param eventData - object containing cookieAge and ruleId
 * @param dispatch - redux dispatch
 */
const trackAllowedMatches = (eventData, dispatch) => {
  dispatch(
    trackEvent({
      category: Category.System,
      entity: Entity.AccessControlListAllowed,
      action: Action.Served,
      payload: eventData,
      team: Team.Retention
    })
  )
}

/**
 * Track specific users that were not matched
 * @param eventData - object containing request/response from ACL
 * @param dispatch - redux dispatch
 */
const trackSpecificUnmatchedUser = (eventData, dispatch) => {
  dispatch(
    trackEvent({
      category: Category.System,
      entity: Entity.AccessControlListUnmatched,
      action: Action.Served,
      payload: eventData,
      team: Team.Retention
    })
  )
}

/**
 * Track wether the user matched the DENY or ALLOW ACL lists
 * @param payload - user payload
 * @param rule - rule action and id
 * @param dispatch - redux dispatch
 */
export const trackAccessControlList = (
  payload: FetchAccessControlParams['payload'],
  hits: Hits[],
  rule,
  dispatch
) => {
  const action = rule?.action
  const ruleId = rule?.ruleId

  const hasDenyToken = DENY_TOKEN === action
  const hasAllowToken = ALLOW_TOKEN === action
  const hasMatched = hasDenyToken || hasAllowToken

  if (hasMatched) {
    const cookieAge = getCookieAgeFromAction(action)
    const eventData = {
      cookieAge,
      ruleId
    }

    if (hasDenyToken)
      return trackDeniedMatches(eventData, payload?.user, dispatch)
    return trackAllowedMatches(eventData, dispatch)
  }

  const isINCountry = payload?.ip?.country === INDIAN_COUNTRY_CODE
  const isUserIpAnonymous = payload?.ip?.isAnonymous === 'yes'
  const eventData = {request: payload, response: hits}

  const trackSpecificUser = isINCountry || isUserIpAnonymous

  if (trackSpecificUser) return trackSpecificUnmatchedUser(eventData, dispatch)
}
